export const ROUTES = {
    REPORT_GROUPS: '/report-groups',
    REPORTS: '/reports',
    SURVEYS: '/surveys',
    BIODATA: '/biodata',
    CUSTOMERS: '/customers'
};
